import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAgencyConfiguration, updateAgencyConfiguration } from './api';
import { ConfigurationResponse } from './types';
import { queryClient } from 'providers/AllProviders';

export function useGetAgencyConfiguration(options?: UseQueryOptions<ConfigurationResponse, Error>) {
  return useQuery<ConfigurationResponse>({
    queryKey: ['agencyConfiguration'],
    queryFn: getAgencyConfiguration,
    ...options
  });
}

export function useUpdateAgencyConfiguration() {
  return useMutation({
    mutationFn: (payload: ConfigurationResponse) => updateAgencyConfiguration(payload),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['usage_analytics'] });
      queryClient.refetchQueries({ queryKey: ['usage_breakdown'] });
      queryClient.invalidateQueries({
        queryKey: ['agencyConfiguration'],
        refetchType: 'active'
      });
    }
  });
}
